module.exports = __webpack_public_path__ + "static/media/BentonSansCond-BoldItalic.a6640d89.otf";